import React, { ChangeEvent, useMemo } from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';
import { SelectType } from '../../useSelectData';

const FILTER_FIRST_KEY = 'job';
const LAST_FIRST_KEY = 'workType';

const cx = cls(styles);
/**
 * filter-box
 * @returns
 */

type SelectProps = {
	selectData: SelectType[];
	customSelEvent: (value: string, type: string) => void;
};

export default function Filterbox(props: SelectProps) {
	const jobSelectData = useMemo(() => {
		return props.selectData.map((v: SelectType) => ({
			[FILTER_FIRST_KEY]: v[FILTER_FIRST_KEY],
		}));
	}, [props.selectData]);

	const typeSelectData = useMemo(() => {
		return props.selectData.reduce((pre: SelectType[], next: SelectType) => {
			if (!pre.find((vv: SelectType) => vv[LAST_FIRST_KEY] === next[LAST_FIRST_KEY])) {
				pre.push(next);
			}
			return pre;
		}, []);
	}, [props.selectData]);

	const changeSelect = (e: ChangeEvent<HTMLSelectElement>, type: string) => {
		props.customSelEvent(e.target.value, type);
	};

	return (
		<div className={cx('filter-box')}>
			<select onChange={(e) => changeSelect(e, FILTER_FIRST_KEY)} defaultValue="">
				<option value="" disabled>
					job
				</option>
				{jobSelectData.map((item, index) => (
					<option key={index} value={item.job}>
						{item.job}
					</option>
				))}
			</select>
			<select onChange={(e) => changeSelect(e, LAST_FIRST_KEY)} defaultValue="" className={cx('type-select')}>
				<option value="" disabled>
					type
				</option>
				{typeSelectData.map((item, index) => (
					<option key={index} value={item.workType}>
						{item.workType}
					</option>
				))}
			</select>
		</div>
	);
}
